import React from 'react';
import PropTypes from 'prop-types';
import CategoryButton from '../../base/CategoryButton';

/**
 * CategoriesButtons component
 * @property {Array} items - button items
 * @returns {JSX}
 */
const CategoriesButtons = ({ items }) => {
  return (
    <div className="container">
      <div className="row">
        {items.map(item => (
          <CategoryButton
            key={item.key}
            titlebutton={item.titlebutton}
            link={item.link}
            activebutton={item.activebutton}
          />
        ))}
      </div>
    </div>
  );
};

CategoriesButtons.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      titlebutton: PropTypes.string,
      activebutton: PropTypes.bool,
      link: PropTypes.string
    })
  )
};

export default CategoriesButtons;
